/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaUser } from 'react-icons/fa';
import React from 'react';
// nodejs library that concatenates classes
import classnames from 'classnames';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// reactstrap components
// import { Button } from 'antd';
import {
  Button,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  ListGroupItem,
  ListGroup,
  Media,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from 'reactstrap';
import StudentContainer from 'components/Containers/StudentContainer';
import { AUTH_LOG_OUT } from '../../modules/Login/actions/types';
import Notification from './Notification';

const auth = ['ngothanhtung.it@gmail.com', 'nmhaof@gmail.com'];
function AdminNavbar({ theme, sidenavOpen, toggleSidenav }) {
  const loggedInUser = useSelector((state) => state.authReducer.loggedInUser);
  const history = useHistory();

  const dispatch = useDispatch();
  // function that on mobile devices makes the search open
  const openSearch = () => {
    document.body.classList.add('g-navbar-search-showing');
    setTimeout(() => {
      document.body.classList.remove('g-navbar-search-showing');
      document.body.classList.add('g-navbar-search-show');
    }, 150);
    setTimeout(() => {
      document.body.classList.add('g-navbar-search-shown');
    }, 300);
  };
  // function that on mobile devices makes the search close
  const closeSearch = () => {
    document.body.classList.remove('g-navbar-search-shown');
    setTimeout(() => {
      document.body.classList.remove('g-navbar-search-show');
      document.body.classList.add('g-navbar-search-hiding');
    }, 150);
    setTimeout(() => {
      document.body.classList.remove('g-navbar-search-hiding');
      document.body.classList.add('g-navbar-search-hidden');
    }, 300);
    setTimeout(() => {
      document.body.classList.remove('g-navbar-search-hidden');
    }, 500);
  };

  return (
    <>
      <Navbar className={classnames('navbar-top navbar-expand border-bottom', { 'navbar-dark bg-info': theme === 'dark' }, { 'navbar-light bg-secondary': theme === 'light' })}>
        <Container fluid>
          <Collapse navbar isOpen>
            {/* <Form className={classnames('navbar-search form-inline mr-sm-3', { 'navbar-search-light': theme === 'dark' }, { 'navbar-search-dark': theme === 'light' })}>
              <FormGroup className='mb-0'>
                <InputGroup className='input-group-alternative input-group-merge'>
                  <InputGroupAddon addonType='prepend'>
                    <InputGroupText>
                      <i className='fas fa-search' />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder='Tìm kiếm' type='text' />
                </InputGroup>
              </FormGroup>
              <button aria-label='Close' className='close' type='button' onClick={closeSearch}>
                <span aria-hidden>×</span>
              </button>
            </Form> */}

            <Nav className='align-items-center ml-md-auto' navbar>
              <NavItem className='d-xl-none'>
                <div className={classnames('pr-3 sidenav-toggler', { active: sidenavOpen }, { 'sidenav-toggler-dark': theme === 'dark' })} onClick={toggleSidenav}>
                  <div className='sidenav-toggler-inner'>
                    <i className='sidenav-toggler-line' />
                    <i className='sidenav-toggler-line' />
                    <i className='sidenav-toggler-line' />
                  </div>
                </div>
              </NavItem>
              <NavItem className='d-sm-none'>
                <NavLink onClick={openSearch}>
                  <i className='ni ni-zoom-split-in' />
                </NavLink>
              </NavItem>
              <StudentContainer>
                {/* <NavItem nav="true">
                  <Button
                    className='mr-2'
                    size='sm'
                    onClick={() => {
                      history.push('/lms/student/books');
                    }}
                  >
                    Kích hoạt sách
                  </Button>
                </NavItem> */}

                {auth.includes(loggedInUser.email) && (
                  <NavItem nav='true'>
                    <Button
                      className='mr-2'
                      size='sm'
                      onClick={() => {
                        history.push('/lms/student/beans');
                      }}
                    >
                      200 beans
                    </Button>
                  </NavItem>
                )}
              </StudentContainer>

              {/* NOTIFICATION */}
              <Notification color={theme === 'test-bank' ? '#525f7f' : undefined} />

              {/* <UncontrolledDropdown nav>
                <DropdownToggle className='nav-link' color='' tag='a'>
                  <i className='ni ni-ungroup' />
                </DropdownToggle>
                <DropdownMenu className='dropdown-menu-lg dropdown-menu-dark bg-default' right>
                  <Row className='shortcuts px-4'>
                    <Col className='shortcut-item' href='#lms' onClick={(e) => e.preventDefault()} xs='4' tag='a'>
                      <span className='shortcut-media avatar rounded-circle bg-gradient-red'>
                        <i className='ni ni-calendar-grid-58' />
                      </span>
                      <small>Calendar</small>
                    </Col>
                    <Col className='shortcut-item' href='#lms' onClick={(e) => e.preventDefault()} xs='4' tag='a'>
                      <span className='shortcut-media avatar rounded-circle bg-gradient-orange'>
                        <i className='ni ni-email-83' />
                      </span>
                      <small>Email</small>
                    </Col>
                    <Col className='shortcut-item' href='#lms' onClick={(e) => e.preventDefault()} xs='4' tag='a'>
                      <span className='shortcut-media avatar rounded-circle bg-gradient-info'>
                        <i className='ni ni-credit-card' />
                      </span>
                      <small>Payments</small>
                    </Col>
                    <Col className='shortcut-item' href='#lms' onClick={(e) => e.preventDefault()} xs='4' tag='a'>
                      <span className='shortcut-media avatar rounded-circle bg-gradient-green'>
                        <i className='ni ni-books' />
                      </span>
                      <small>Reports</small>
                    </Col>
                    <Col className='shortcut-item' href='#lms' onClick={(e) => e.preventDefault()} xs='4' tag='a'>
                      <span className='shortcut-media avatar rounded-circle bg-gradient-purple'>
                        <i className='ni ni-pin-3' />
                      </span>
                      <small>Maps</small>
                    </Col>
                    <Col className='shortcut-item' href='#lms' onClick={(e) => e.preventDefault()} xs='4' tag='a'>
                      <span className='shortcut-media avatar rounded-circle bg-gradient-yellow'>
                        <i className='ni ni-basket' />
                      </span>
                      <small>Shop</small>
                    </Col>
                  </Row>
                </DropdownMenu>
              </UncontrolledDropdown> */}
            </Nav>
            <Nav className='align-items-center ml-auto ml-md-0' navbar>
              <UncontrolledDropdown nav>
                <DropdownToggle className='nav-link pr-0' color='' tag='a'>
                  <Media className='align-items-center'>
                    <span className='avatar avatar-sm rounded-circle' style={{ backgroundColor: '#ffffff' }}>
                      {loggedInUser.avatarUrl ? <img alt='...' src={loggedInUser.avatarUrl} /> : <FaUser className='text-primary' />}
                    </span>
                    <Media className='ml-2 d-none d-lg-block'>
                      <span className='mb-0 text-sm font-weight-bold'>{loggedInUser?.fullName}</span>
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem className='noti-title' header tag='div'>
                    <h6 className='text-overflow m-0'>
                      <span>Tài khoản </span>
                      {loggedInUser?.role === 'teacher' ? 'giáo viên' : 'học sinh'}
                    </h6>
                  </DropdownItem>
                  <DropdownItem
                    href='#lms'
                    tag='a'
                    onClick={(e) => {
                      e.preventDefault();
                      history.push('/lms/profile');
                    }}
                  >
                    <i className='ni ni-single-02' />
                    <span>Tài khoản</span>
                  </DropdownItem>
                  {/* <DropdownItem href='#lms' onClick={(e) => e.preventDefault()}>
                    <i className='ni ni-settings-gear-65' />
                    <span>Cấu hình</span>
                  </DropdownItem>
                  <DropdownItem href='#lms' onClick={(e) => e.preventDefault()}>
                    <i className='ni ni-calendar-grid-58' />
                    <span>Hoạt động</span>
                  </DropdownItem>
                  <DropdownItem href='#lms' onClick={(e) => e.preventDefault()}>
                    <i className='ni ni-support-16' />
                    <span>Hỗ trợ</span>
                  </DropdownItem>
                  <DropdownItem divider /> */}
                  <DropdownItem
                    href='#lms'
                    onClick={(e) => {
                      localStorage.clear();
                      history.push('/');
                      dispatch({ type: AUTH_LOG_OUT });
                    }}
                  >
                    <i className='ni ni-user-run' />
                    <span>Thoát</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

AdminNavbar.defaultProps = {
  toggleSidenav: () => {},
  sidenavOpen: false,
  theme: 'dark',
};
AdminNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(['dark', 'light', 'test-bank']),
};

export default AdminNavbar;
